<template>
  <div>
    <!-- <search-section class="d-none d-lg-block" /> -->
    <main-body />
  </div>
</template>

<script>
// import SearchSection from "@/components/SearchSection.vue";
import MainBody from "@/components/MainBody.vue";
export default {
  name: "HomePage",
  components: {
    // SearchSection,
    MainBody
  },
};
</script>

<style lang="scss" scoped>
</style>

